import { FormInstance } from "antd/es/form";
import React from "react";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { Blank_ScreenContext } from "../blank/blank-context";

declare let window: any;

export interface IKapatilmamisFaturalar_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IKapatilmamisFaturalar_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
}

export class KapatilmamisFaturalar_ScreenBase extends React.PureComponent<
  IKapatilmamisFaturalar_ScreenProps,
  any
> {
  static contextType = Blank_ScreenContext;
  declare context: React.ContextType<typeof Blank_ScreenContext>;
  kapatilmamisfaturalar_47246_value_kuikaDateRef: React.RefObject<any>;
  kapatilmamisfaturalar_44703_value_kuikaDateRef: React.RefObject<any>;
  kapatilmamisfaturalar_501002_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "e6553d05-98ae-4ab8-be91-cc851f894a0b",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [
        {
          Id: 501002,
          PropertyName: "nodatafoundmessage",
          Value: "NO RECORDS FOUNDED",
          TagName: "Table1_nodatafoundmessage",
        },
        {
          Id: 219565,
          PropertyName: "value",
          Value: "OPEN INVOICES",
          TagName: "Label16_value",
        },
        {
          Id: 435981,
          PropertyName: "title",
          Value: "PRODUCT CODE",
          TagName: "TableTemplateColumn1_0_title",
        },
        {
          Id: 197987,
          PropertyName: "title",
          Value: "PRODUCT NAME",
          TagName: "TableTemplateColumn2_title",
        },
        {
          Id: 501159,
          PropertyName: "title",
          Value: "ORDER NO",
          TagName: "TableTemplateColumn3_title",
        },
        {
          Id: 835743,
          PropertyName: "title",
          Value: "ORDER DATE",
          TagName: "TableTemplateColumn4_title",
        },
        {
          Id: 687263,
          PropertyName: "title",
          Value: "ORDER AMOUNT",
          TagName: "TableTemplateColumn5_title",
        },
        {
          Id: 431288,
          PropertyName: "title",
          Value: "SHIPPED AMOUNT",
          TagName: "TableTemplateColumn6_title",
        },
        {
          Id: 280373,
          PropertyName: "title",
          Value: "REMAIN AMOUNT",
          TagName: "TableTemplateColumn7_title",
        },
        {
          Id: 47246,
          PropertyName: "placeholder",
          Value: "START DATE",
          TagName: "Date4_placeholder",
        },
        {
          Id: 44703,
          PropertyName: "placeholder",
          Value: "END DATE",
          TagName: "Date4_placeholder",
        },
        {
          Id: 401089,
          PropertyName: "label",
          Value: "LIST ALL",
          TagName: "Button3_label",
        },
      ],
    },
    {
      Id: "cd8e66ca-d8dd-1a05-bdac-f63ba9f6777b",
      Name: "fr_FR",
      ShortName: "French",
      LanguagePhrases: [
        {
          Id: 501002,
          PropertyName: "nodatafoundmessage",
          Value: "Aucun résultat",
          TagName: "Table1_nodatafoundmessage",
        },
        {
          Id: 219565,
          PropertyName: "value",
          Value: "Factures non clôturées",
          TagName: "Label16_value",
        },
        {
          Id: 435981,
          PropertyName: "title",
          Value: "Code produit",
          TagName: "TableTemplateColumn1_0_title",
        },
        {
          Id: 197987,
          PropertyName: "title",
          Value: "Nom du produit",
          TagName: "TableTemplateColumn2_title",
        },
        {
          Id: 501159,
          PropertyName: "title",
          Value: "N° commande",
          TagName: "TableTemplateColumn3_title",
        },
        {
          Id: 835743,
          PropertyName: "title",
          Value: "Date de commande",
          TagName: "TableTemplateColumn4_title",
        },
        {
          Id: 687263,
          PropertyName: "title",
          Value: "Quantité commandée",
          TagName: "TableTemplateColumn5_title",
        },
        {
          Id: 431288,
          PropertyName: "title",
          Value: "Quantité livrée",
          TagName: "TableTemplateColumn6_title",
        },
        {
          Id: 280373,
          PropertyName: "title",
          Value: "Quantité restante",
          TagName: "TableTemplateColumn7_title",
        },
        {
          Id: 47246,
          PropertyName: "placeholder",
          Value: "Date de début",
          TagName: "Date4_placeholder",
        },
        {
          Id: 44703,
          PropertyName: "placeholder",
          Value: "Date de fin",
          TagName: "Date4_placeholder",
        },
        {
          Id: 401089,
          PropertyName: "label",
          Value: "Afficher",
          TagName: "Button3_label",
        },
      ],
    },
    {
      Id: "ef30cc19-66ab-ea0f-c492-2e57cb69ffd2",
      Name: "es_ES",
      ShortName: "Spanish",
      LanguagePhrases: [
        {
          Id: 501002,
          PropertyName: "nodatafoundmessage",
          Value: "No se encontraron registros para agregar",
          TagName: "Table1_nodatafoundmessage",
        },
        {
          Id: 219565,
          PropertyName: "value",
          Value: "Facturas sin cerrar",
          TagName: "Label16_value",
        },
        {
          Id: 435981,
          PropertyName: "title",
          Value: "Código de producto",
          TagName: "TableTemplateColumn1_0_title",
        },
        {
          Id: 197987,
          PropertyName: "title",
          Value: "Nombre del producto",
          TagName: "TableTemplateColumn2_title",
        },
        {
          Id: 501159,
          PropertyName: "title",
          Value: "No. de pedido",
          TagName: "TableTemplateColumn3_title",
        },
        {
          Id: 835743,
          PropertyName: "title",
          Value: "Fecha del pedido",
          TagName: "TableTemplateColumn4_title",
        },
        {
          Id: 687263,
          PropertyName: "title",
          Value: "Cantidad del pedido",
          TagName: "TableTemplateColumn5_title",
        },
        {
          Id: 431288,
          PropertyName: "title",
          Value: "Cantidad enviada",
          TagName: "TableTemplateColumn6_title",
        },
        {
          Id: 280373,
          PropertyName: "title",
          Value: "Cantidad restante",
          TagName: "TableTemplateColumn7_title",
        },
        {
          Id: 47246,
          PropertyName: "placeholder",
          Value: "Fecha de inicio",
          TagName: "Date4_placeholder",
        },
        {
          Id: 44703,
          PropertyName: "placeholder",
          Value: "Fecha de finalización",
          TagName: "Date4_placeholder",
        },
        {
          Id: 401089,
          PropertyName: "label",
          Value: "Lista",
          TagName: "Button3_label",
        },
      ],
    },
    {
      Id: "f1e96f18-81d9-6312-1ebe-139d61cd7180",
      Name: "tr_TR",
      ShortName: "Turkish",
      LanguagePhrases: [],
    },
    {
      Id: "64eb09f7-618d-4797-9bf0-e7669c3f9eba",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 219565, PropertyName: "value", Value: "Kapatılmamış Faturalar" },
        { Id: 47246, PropertyName: "placeholder", Value: "Başlangıç Tarihi" },
        { Id: 44703, PropertyName: "placeholder", Value: "Bitiş Tarihi" },
        { Id: 401089, PropertyName: "label", Value: "Listele" },
        {
          Id: 501002,
          PropertyName: "nodatafoundmessage",
          Value: "Listelenecek Kayıt Bulunamadı",
        },
        { Id: 435981, PropertyName: "title", Value: "Ürün Kodu" },
        { Id: 653107, PropertyName: "value", Value: "label" },
        { Id: 197987, PropertyName: "title", Value: "Ürün Adı" },
        { Id: 926385, PropertyName: "value", Value: "label" },
        { Id: 501159, PropertyName: "title", Value: "Sipariş No" },
        { Id: 455729, PropertyName: "value", Value: "label" },
        { Id: 835743, PropertyName: "title", Value: "Sipariş Tarihi" },
        { Id: 941477, PropertyName: "value", Value: "label" },
        { Id: 687263, PropertyName: "title", Value: "Sipariş Mik." },
        { Id: 342464, PropertyName: "value", Value: "label" },
        { Id: 431288, PropertyName: "title", Value: "Sevk. Miktarı" },
        { Id: 477062, PropertyName: "value", Value: "label" },
        { Id: 280373, PropertyName: "title", Value: "Kalan Mik." },
        { Id: 718258, PropertyName: "value", Value: "label" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  private _prevMasterPageInitLoaded: boolean = false;
  private _prevMasterPageRecurringLoaded: boolean = false;
  private _prevShouldTriggerPageInit: boolean = false;
  constructor(props) {
    super(props);
    this.kapatilmamisfaturalar_47246_value_kuikaDateRef = React.createRef();
    this.kapatilmamisfaturalar_44703_value_kuikaDateRef = React.createRef();
    this.kapatilmamisfaturalar_501002_value_kuikaTableRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "kapatilmamisfaturalar",
        "blank_screen"
      );
      return;
    }
    this.context.registerCallbackFunction(this.callCallbackFunction.bind(this));

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (false) {
    }

    KuikaAppManager.calculateAndSetBodyHeight(
      "kapatilmamisfaturalar",
      "blank_screen"
    );

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight(
      "kapatilmamisfaturalar",
      "blank_screen"
    );
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
  }
}
